import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";


const BlogDetail = () => {
    const {t} = useTranslation();
  
  const [BlogUser, setBlogUser] = useState({
    blog_image: "",
    blog_head: "",
    blog_desp: "",
    blog_date:""
  });
  const { id } = useParams();

  useEffect(() => {
    const BlogData = async () => {
      try {
        const response = await axios.post(
          "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_blog_by_id",
          {
            blog_id: id,
          }
        );
        setBlogUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    BlogData();
  }, [id]);


  return (
    <section>
      <div className="container spad blog-section">
        <div className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="breadcrumb-text"
                  data-aos="fade-down"
                  data-aos-duration={3000}
                >
                  <h2>Our Blog Details</h2>
                  <div className="bt-option">
                    <Link to="/">{t("home")}</Link>
                    <span>{t("blog")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
            <div className="col-lg-12">
              <div className="shadow-sm p-4">
                  <h3 className="card-title">{BlogUser.blog_head}</h3>
                  <p className="text-muted">
                    By Admin | {BlogUser.blog_date}
                  </p>
                <div className="blogcard-img-top">
                  <img src={`https://cyberathon.com/silverapartment/${BlogUser.blog_image}`} loading="lazy" alt="Blog" />
                </div>
                <div className="card-body mt-5">
                  <p dangerouslySetInnerHTML={{__html: BlogUser.blog_desp}}></p>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default BlogDetail;
